import firebase from 'firebase';

export const getCCMRManual = firebase.functions().httpsCallable('getCCMRManual');
export const saveCCMRManual = firebase.functions().httpsCallable('saveCCMRManual');
export const getCCMRIndicators = firebase.functions().httpsCallable('getCCMRIndicators');
export const getGraduationDataIndicators = firebase.functions().httpsCallable('getGraduationDataIndicators');
export const getDistrictOrSchoolData = firebase.functions().httpsCallable('getDistrictOrSchoolData');

export default 'SchoolSettings.api.js';
